/* eslint-disable max-classes-per-file */
const generateId = () => `${Math.random().toString(16).slice(2)}-${new Date().getTime()}`;
class BrazeMessage {
    constructor(id, message, appboyInstance, slotName, cache) {
        this.id = id;
        this.message = message;
        this.appboy = appboyInstance;
        this.slotName = slotName;
        this.cache = cache;
    }
    logImpression() {
        try {
            this.appboy.logInAppMessageImpression(this.message);
        }
        catch (error) {
            window.guardian.modules.sentry.reportError(error, 'BrazeMessage.logImpression');
        }
        this.cache.remove(this.slotName, this.id);
    }
    logButtonClick(internalButtonId) {
        const button = new this.appboy.InAppMessageButton(`Button: ID ${internalButtonId}`, undefined, undefined, undefined, undefined, undefined, internalButtonId);
        try {
            this.appboy.logInAppMessageButtonClick(button, this.message);
        }
        catch (error) {
            window.guardian.modules.sentry.reportError(error, 'BrazeMessage.logButtonClick');
        }
    }
    get extras() {
        return this.message.extras;
    }
}
class BrazeMessages {
    constructor(appboyInstance, cache) {
        this.appboy = appboyInstance;
        this.cache = cache;
        this.freshBannerMessage = this.getFreshMessagesForSlot('Banner');
        this.freshEndOfArticleMessage = this.getFreshMessagesForSlot('EndOfArticle');
    }
    // Generally we only expect a single message per slot max in a pageview. This method
    // returns a promise which will resolve when the first message arrives
    getFreshMessagesForSlot(targetSlotName) {
        return new Promise((resolve) => {
            const callback = (m) => {
                // Cast this as we only ever expect it to be an InAppMessage
                const message = m;
                const { extras } = message;
                if (extras &&
                    extras.slotName &&
                    extras.slotName === targetSlotName) {
                    this.cache.push(targetSlotName, {
                        message,
                        id: generateId(),
                    });
                    resolve(message);
                }
            };
            this.appboy.subscribeToInAppMessage(callback);
        });
    }
    getMessageForBanner() {
        // If there's already a message in the cache, return it
        const messageFromCache = this.cache.peek('Banner', this.appboy);
        if (messageFromCache) {
            return Promise.resolve(new BrazeMessage(messageFromCache.id, messageFromCache.message, this.appboy, 'Banner', this.cache));
        }
        // Otherwise we'll wait for a fresh message to arrive, returning the
        // data from the cache (where it will have already been added)
        return this.freshBannerMessage.then(() => {
            const freshMessageFromCache = this.cache.peek('Banner', this.appboy);
            if (freshMessageFromCache) {
                return new BrazeMessage(freshMessageFromCache.id, freshMessageFromCache.message, this.appboy, 'Banner', this.cache);
            }
            // Generally we don't expect to reach this point
            throw new Error('No messages for Banner slot');
        });
    }
    getMessageForEndOfArticle() {
        // If there's already a message in the cache, return it
        const messageFromCache = this.cache.peek('EndOfArticle', this.appboy);
        if (messageFromCache) {
            return Promise.resolve(new BrazeMessage(messageFromCache.id, messageFromCache.message, this.appboy, 'EndOfArticle', this.cache));
        }
        // Otherwise we'll wait for a fresh message to arrive, returning the
        // data from the cache (where it will have already been added)
        return this.freshEndOfArticleMessage.then(() => {
            const freshMessageFromCache = this.cache.peek('EndOfArticle', this.appboy);
            if (freshMessageFromCache) {
                return new BrazeMessage(freshMessageFromCache.id, freshMessageFromCache.message, this.appboy, 'EndOfArticle', this.cache);
            }
            // Generally we don't expect to reach this point
            throw new Error('No messages for EndOfArticle slot');
        });
    }
}
export { BrazeMessages, BrazeMessage };
